/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import alerts, { AlertsState } from './alerts';
import boardSelector, { BoardSelectorState } from './board-selector';
import boardsMenu, { BoardsMenuState } from './boards-menu';
import closedBoards, { ClosedBoardsState } from './closed-boards';
import collapsibles, { CollapsiblesState } from './collapsibles';
import createMenu, { CreateMenuState } from './create-menu';
import errors, { ErrorState } from './errors';
import header, { HeaderState } from './header';
import labels, { LabelUiState } from './labels';
import navigating, { NavigatingState } from './navigating';
import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay, { OverlayState } from './overlay';
import popovers, { PopoversState } from './popovers';
import search, { SearchUiState } from './search';
import tooltips, { TooltipsState } from './tooltips';
import {
  MemberHomeProfileState,
  MemberHomeProfileReducer as memberHomeProfile,
} from 'app/gamma/src/modules/state/ui/member-home-profile';

export * from './alerts';
export * from './board-selector';
export * from './boards-menu';
export * from './closed-boards';
export * from './collapsibles';
export * from './create-menu';
export * from './header';
export * from './labels';
export * from './navigating';
export * from './notifications-pane';
export * from './overlay';
export * from './popovers';
export * from './search';
export * from './channel-switcher';
export * from './member-home-profile';

export interface UiState {
  alerts: AlertsState;
  boardSelector: BoardSelectorState;
  boardsMenu: BoardsMenuState;
  closedBoards: ClosedBoardsState;
  collapsibles: CollapsiblesState;
  createMenu: CreateMenuState;
  errors: ErrorState;
  header: HeaderState;
  labels: LabelUiState;
  memberHomeProfile: MemberHomeProfileState;
  navigating: NavigatingState;
  notificationsPane: NotificationsPaneState;
  overlay: OverlayState;
  popovers: PopoversState;
  tooltips: TooltipsState;
  search: SearchUiState;
}

export default combineReducers({
  alerts,
  boardSelector,
  boardsMenu,
  closedBoards,
  collapsibles,
  createMenu,
  errors,
  labels,
  header,
  memberHomeProfile,
  navigating,
  notificationsPane,
  overlay,
  popovers,
  tooltips,
  search,
});
